import type { SavedBookingSeed } from './create-appointment-panel';

/**
 * The `onSaveSuccess` payload of a successful create save: the picked patient, the booked slot and,
 * since PROD-1395, the id of the appointment the server created (`useBookAppointment` returns `{ id }`).
 * Kept apart from the panel so the shape is tested without driving the whole form.
 */
export function buildSavedBookingSeed(
  created: { id?: string | null } | null | undefined,
  values: {
    patientId?: string | null;
    patientName?: string | null;
    slotStart?: string | null;
    slotEnd?: string | null;
  },
): SavedBookingSeed {
  return {
    appointmentId: created?.id || undefined,
    patientId: values.patientId ?? undefined,
    patientName: values.patientName ?? undefined,
    slotStart: values.slotStart ?? undefined,
    slotEnd: values.slotEnd ?? undefined,
  };
}
